import updeep from 'updeep';
import { handleActions } from 'redux-actions';

const receiveSectionComments = (state, { payload: { sectionId, data } }) => {
  // we must accept flattened as well as paginated comment listings
  let count = data.count ?? 0;
  let next = data.next ?? null;


  const receivedData = {}
  data.results.forEach( c => {receivedData[c.id] = c});
  
  const newCommentData = {
    ...(state[sectionId].commentData ?? {}),
    ...receivedData,
  }
  const ids = Object.keys(newCommentData);
  const pinnedIds = ids.filter(id => newCommentData[id].pinned).map(id => parseInt(id));
  const rootIds = ids.filter(id => (!newCommentData[id].pinned && !newCommentData[id].comment)).map(id => parseInt(id))

  const lists = {
    pinned: pinnedIds,
    base: rootIds,
  }
  return {
    ...state,
    [sectionId]: {
      ...state[sectionId],
      isFetching: false,
      fetchTime: new Date(),
      //results: data.results, // TODO: remove results
      commentData: newCommentData,
      lists,
      count,
      next,
    }
  }

  /*return updeep(
    {
      [sectionId]: {
        isFetching: false,
        fetchTime: new Date(),
        results: combinedResults,
        count,
        next,
      },
    },
    state,
  );*/
};

const receiveNewestSectionComments = (state, { payload: { sectionId, data } }) => {
  // we must accept flattened as well as paginated comment listings

  const results = data.results;
  
  return {
    ...state,
    [sectionId]: {
      ...state[sectionId],
      newest: results,
    }
  }
};


const postedComment = (state, { payload: { sectionId, jumpTo, data } }) => {
  const lists = {...state[sectionId].lists};
  if (!data.comment) {
    const key = data.pinned ? 'pinned' : 'base';
    lists[key] = lists[key].concat(data.id)
  }

  return {
    ...state,
    [sectionId]: {
      ...state[sectionId],
      lists: lists,
      commentData: {...state[sectionId].commentData, [data.id]:data},
      jumpTo,
    }
  };
};

/**
 * When comment is edited, no need to fetch the entire list again.
 * Update the object in array.
 */
const editedComment = (state, { payload: { sectionId, commentId, commentData } }) => {
  let lists = state[sectionId].lists;
  if (state[sectionId].commentData[commentId].pinned != commentData.pinned) {
    // pinned state has changed so the lists need to be updated
    let pinned = lists.pinned;
    let base = lists.base
    if (commentData.pinned) {
      pinned = pinned.concat(commentId) // add to pinned
      base = base.filter(c => c != commentId) // remove from base
    } else {
      pinned = pinned.filter(c => c != commentId) // remove from pinned
      base = base.concat(commentId) // add to base
    }
    lists = {
      pinned,
      base,
    }
  }
  const stateCommentData = state[sectionId].commentData[commentId];
  return {
    ...state,
    [sectionId]: {
      ...state[sectionId],
      commentData: {
        ...state[sectionId].commentData, 
        [commentId]: {
          ...stateCommentData,
          ...commentData,
          avatar: stateCommentData.avatar, // FIXME: backend returns null avatar here
        }
      },
      lists,
    }
  };
};

/**  */
const deletedComment = (state, { payload: { sectionId, commentId } }) => {
  
  const commentData = state[sectionId].commentData[commentId]

  return {
    ...state,
    [sectionId]: {
      ...state[sectionId],
      commentData: {
        ...state[sectionId].commentData, 
        [commentId]: {
          ...commentData, 
          deleted: true,
          can_edit: false,
          images: [],
          content: '',
          author_name: '',
          organization: null,
        }},
    }
  };
};

const postedCommentVote = (
  state,
  { payload: { commentId, sectionId, n_votes, voted_by_user} },
) => {
  // the vote went through

  return {
    ...state,
    [sectionId]: {
      ...state[sectionId],
      commentData: {
        ...state[sectionId].commentData,
        [commentId]: {
          ...state[sectionId].commentData[commentId],
          n_votes,
          voted_by_user,
        }
      }
    }
  }
};

const beginFetchSectionComments = (
  state,
  { payload: { sectionId, ordering, cleanFetch } },
) => {
  if (
    state[sectionId] &&
    state[sectionId].ordering === ordering &&
    !cleanFetch
  ) {
    return updeep(
      {
        [sectionId]: {
          isFetching: true,
        },
      },
      state,
    );
  }
  return {
    ...state,
    [sectionId]: {
      ...(state[sectionId] ?? {}),
      isFetching: true,
      commentData: state[sectionId]?.commentData ?? {},
      lists: state[sectionId]?.lists ?? {pinned:[], base:[]},
      ordering: ordering ?? state[sectionId].ordering,
    }
  }
};

/**
 * Begin fetching the sub comments.
 * Show loading spinner on the parent comment description.
 */
const beginFetchSubComments = (
  state,
  { payload: { sectionId, sectionCommentId, commentId } },
) => {
  
  return {
    ...state,
    [sectionId]: {
      ...state[sectionId],
      commentData: {
        ...state[sectionId].commentData,
        [sectionCommentId]: {
          ...state[sectionId].commentData[sectionCommentId],
          loadingSubComments: true,
        }
      }
    }
  }
};

/**
 * Once comments are fetched, update the store with sub comments.
 */
const subCommentsFetched = (
  state,
  { payload: { sectionId, sectionCommentId, commentId, data, jumpTo } },
) => {

  // The map for comment data useSelector use
  const commentData = data.results.reduce((prev, cur) => {
      return {...prev, [cur.id]: cur}
    }, {...(state[sectionId].commentData || {})}
  )
  const combinedData = {
    ...state[sectionId].commentData, ...commentData
  }
  let baseCommentId = commentId;
  while (combinedData[baseCommentId]?.comment) {
    baseCommentId = combinedData[baseCommentId].comment;
  }

  const baseComment = state[sectionId].commentData[baseCommentId];
  const resultsIds = data.results.map(c => c.id);
  const baseAllSubComments = baseComment.all_sub_comments.concat(
    resultsIds.filter(id => (baseComment.all_sub_comments.indexOf(id) < 0))
  ).sort((a,b) => a < b ? -1 : (a == b ? 0 : 1)); // TODO: Optimize?

  const updatedSection = {
    ...state[sectionId],
    commentData: {
      ...state[sectionId].commentData, 
      ...commentData, 
      [baseCommentId]: {
        ...baseComment, 
        all_sub_comments: baseAllSubComments,
        loadingSubComments: false,
      }
    },
    jumpTo: jumpTo ?? state[sectionId].jumpTo,
  };
  return {
    ...state,
    [sectionId]: updatedSection,
  }
};

const setJumpTo = (state, { payload: { sectionId, jumpTo } }) => {

  return {
    ...state,
    [sectionId]: {
      ...state[sectionId],
      jumpTo: jumpTo,
    }
  }
};

const cleanJumpTo = (state, { payload: { sectionId } }) => {

  return {
    ...state,
    [sectionId]: {
      ...state[sectionId],
      jumpTo: null,
    }
  }
};

/*
* Function find subcomment with id=commentId and update all properties from propertyValueObj
* propertyValueObj ={
* key1: value,
* key2: function(data=>{})
* }
* propertyValueObj's value can be as value or as a function
* If value is function, this function call with data as a parameter
* Return updated data
* */
const updatePropertiesById = (commentId, data, propertyValueObj) => {
  if (data.id == commentId) {
    Object.keys(propertyValueObj).forEach(property => {
      if (propertyValueObj[property] instanceof Function) {
        data[property] = propertyValueObj[property](data);
      } else {
        data[property] = propertyValueObj[property];
      }
    });
    return data;
  }
  if (data.subComments !== undefined && data.subComments.length > 0) {
    for (let i = 0; i < data.subComments.length; i++) {
      data.subComments[i] = updatePropertiesById(commentId, data.subComments[i], propertyValueObj);
    }
  }
  return data;
};

export default handleActions(
  {
    beginFetchSectionComments,
    beginFetchSubComments,
    editedComment,
    postedComment,
    deletedComment,
    postedCommentVote,
    receiveSectionComments,
    receiveNewestSectionComments,
    subCommentsFetched,
    setJumpTo,
    cleanJumpTo,
  },
  {},
);
